export const originItems = [
  { key: 'city', label: 'Kota', value: `Pilih Alamat Asal`, bold: false },
  {
    key: 'operational',
    label: 'Waktu Operasional',
    value: `Pilih Alamat Asal`,
    bold: false,
  },
  {
    key: 'break',
    label: 'Waktu Istirahat',
    value: `Pilih Alamat Asal`,
    bold: false,
  },
]

export const destinationItems = [
  { key: 'city', label: 'Kota', value: `Pilih Alamat Tujuan`, bold: false },
  {
    key: 'operational',
    label: 'Waktu Operasional',
    value: `Pilih Alamat Tujuan`,
    bold: false,
  },
  {
    key: 'break',
    label: 'Waktu Istirahat',
    value: `Pilih Alamat Tujuan`,
    bold: false,
  },
]
